import { useQuery } from '@tanstack/react-query';

import { wolfswapFactionsApi } from '@/lib/api';
import { fetchSpeedConfig } from '@/lib/api/speed';
import { queryKeys } from '@/lib/query';

const CONFIG_STALE_TIME_MS = 5 * 60_000;

/**
 * Reads the public speed-trading backend config (`GET /speed/config`): the
 * testnet flag, fee monetization path and contract addresses. Used for the
 * TESTNET indicator and fee disclosure. Public (no auth), cached for 5 min.
 */
export function useSpeedConfig() {
    return useQuery({
        queryKey: queryKeys.speed.config(),
        queryFn: async ({ signal }) =>
            fetchSpeedConfig(wolfswapFactionsApi.extend({ signal })),
        staleTime: CONFIG_STALE_TIME_MS,
    });
}
